module.exports = __webpack_public_path__ + "img/HA1507-193.4e6ff4cb.jpg";